import styles from "./../Lobby.module.scss";
import React from "react";

type props = {
    open: boolean;
    title: string;
    password: string;
    isCreateDisabled: boolean;
    onTitleChange: (value: string) => void;
    onPasswordChange: (value: string) => void;
    onCreate: (capacity: number) => void;
    onClose: () => void;
};

const CreateLobbyModal: React.FC<props> = ({
                                               open,
                                               title,
                                               password,
                                               isCreateDisabled,
                                               onTitleChange,
                                               onPasswordChange,
                                               onCreate,
                                               onClose,
                                           }) => {
    if (!open) return null;

    return (
        <div className={styles.modalBackdrop} onMouseDown={onClose}>
            <div
                className={styles.modal}
                role="dialog"
                aria-modal="true"
                aria-labelledby="create-lobby-title"
                onMouseDown={(e) => e.stopPropagation()}
            >
                <h2 id="create-lobby-title" className={styles.modalTitle}>
                    Create Lobby
                </h2>

                <label className={styles.modalLabel}>
                    <span className={styles.modalLabelText}>Title</span>
                    <input
                        className={styles.modalInput}
                        value={title}
                        onChange={(e) => onTitleChange(e.target.value)}
                        placeholder="My awesome game"
                    />
                </label>

                <label className={styles.modalLabel}>
                    <span className={styles.modalLabelText}>Password</span>
                    <input
                        className={styles.modalInput}
                        type="password"
                        value={password}
                        onChange={(e) => onPasswordChange(e.target.value)}
                        placeholder="Secret code"
                    />
                </label>

                <div className={styles.modalHint}>
                    Share this password only with people you want in the lobby.
                </div>

                <div className={styles.modalButtons}>
                    <button
                        disabled={isCreateDisabled}
                        className={styles.modalBtnSecondary}
                        onClick={() => onCreate(1)}
                    >
                        Solo
                    </button>

                    <button
                        disabled={isCreateDisabled}
                        className={styles.modalBtnPrimary}
                        onClick={() => onCreate(0)}
                    >
                        Create
                    </button>

                    <button className={styles.modalBtnSecondary} onClick={onClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateLobbyModal;
